import React, { Children } from 'react'
import { WarningItemProps } from './types'

export const WarningItem = ({ className }: WarningItemProps) => (
  <li className={[`mt-1 text-warning-color text-sm font-normal`, className || ''].join(' ')}>
    {Children}
  </li>
)
